import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MemberAssessmentsComponent } from 'src/app/app-components/member-detail/member-detail-tabs/member-assessments/member-assessments.component';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-member-assessments-dialog',
  templateUrl: './member-assessments-dialog.component.html',
  styleUrl: './member-assessments-dialog.component.scss'
})
export class MemberAssessmentsDialogComponent {

  @Input() memberCIN: string;
  @Input() calProviderId: string;
  @Output() onCancel = new EventEmitter();
  @ViewChild('memberassessment')  memberassessment: MemberAssessmentsComponent

  public display: boolean = true;
  public showAlert: number = 0;
  public validationErrorMessage: string = "";
  
  constructor(private sessionService: SessionService) {

  }
    
  public cancelDialog() {
    this.onCancel.emit();
  }

  public onsavesuccess() {
    this.showAlert = 1
  }

  public onsavefailed()  { 
    this.showAlert = 2;
  }

  public onchange() {
    this.showAlert = 0;  
  }

  public get canBack(): boolean {
    return this.memberassessment && this.memberassessment.selectedassessment ? true : false;
  }

  public onSubmit() {
    var result = this.memberassessment.validate();

    if(result.valid) {
      this.memberassessment.saveAssessment();
    }
    else {
      this.showAlert = 3
      this.validationErrorMessage = result.error;
    } 
  }  

  public get canAttest() : boolean {
    if(this.sessionService.isInternalUser) {
      return false;
    }
    else {
      if(this.memberassessment)
        return this.memberassessment.canSubmit;
      else
        return false;
    }    
  }  

  public onBack() {
    this.showAlert = 0;  
    this.memberassessment.selectedassessment = null;
    this.memberassessment.showAssessments();    
  }
}
